<script>
export default {
  name: 'CustomArrow',
  props: {
    direction: {
      type: String,
      required: true,
      default: 'right',
      validator: function (value) {
        return ['right', 'left', 'up', 'down'].indexOf(value) !== -1
      },
    },
  },
}
</script>

<template>
  <i :class="$style[direction]" />
</template>

<style lang="scss" module scoped>
@import '@design';

i {
  padding: 4px;
  border: solid $darker-gray;
  border-width: 0 2px 2px 0;
  transition: all 0.4s ease;
}
.right {
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
}
.left {
  -webkit-transform: rotate(135deg);
  transform: rotate(135deg);
}

.up {
  -webkit-transform: rotate(-135deg);
  transform: rotate(-135deg);
}

.down {
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
}
</style>
